import type { RouteRecordRaw } from 'vue-router'
import { externalServiceUrls } from '@/utils/external-services'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/console/3d',
  component: Layout,
  meta: {
    title: '3D',
    menu: false,
    link: externalServiceUrls.model,
  },
  children: [
    {
      path: '',
      name: 'three-d',
      component: () => import('@/views/index.vue'),
      meta: {
        title: '3D',
        menu: false,
        breadcrumb: false,
      },
    },
  ],
}

export default routes
